import { Pipe, PipeTransform } from '@angular/core';
import { AlertType, alertTypeLabelsPlural } from "@models/alerts/alerts-enums";

@Pipe({
  name: 'alertsType',
  standalone: true
})
export class AlertsTypePipe implements PipeTransform {
  transform(value: AlertType | undefined | null): string {
    return value != null && value != undefined
      ? alertTypeLabelsPlural[value]
      : '-';
  }
}
